module.exports = __webpack_public_path__ + "media/images/landing/avatar4-0bd31a2a4253a4a20d186ea11910c38e.jpg";